import React from "react";
import styles from "./styles.module.scss";

interface BannerItem {
  url: string;
  alternativeText: string;
}

interface CoverProps {
  banner: BannerItem[];
  bannerMobile?: BannerItem;
}

const BannerCover: React.FC<CoverProps> = ({ banner, bannerMobile }) => {
  return (
    <div className={styles.cover}>
      <img
        className={`desktop ${!bannerMobile || !bannerMobile?.url ? "default" : ""}`}
        src={banner[0].url}
        alt={banner[0].alternativeText}
        fetchPriority="high"
      />
      {bannerMobile?.url && (
        <img
          className="mobile"
          src={bannerMobile.url}
          alt={bannerMobile.alternativeText}
          fetchPriority="high"
        />
      )}
    </div>
  );
};

export default BannerCover;
